<template>
    <div class="mbody">
        <div class="settholder">
            <div style="text-align: center;font-size: 17pt;">Settings</div>

        <hr style="width: 90%;">


            <div>GAS Limit : <input type="text" v-model="cur_gas_limit" /></div>

            <div style="justify-self: center; align-self: center;"><button @click="save_settings()">Save</button></div>

        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';

export default {
    name: ENUMS.VIEWS.SETTINGS
    , methods: {
        save_settings() {
            var qthis = this
            localStorage.settings = JSON.stringify(
                { GAS_LIMIT: parseInt( qthis.cur_gas_limit )}
            )
        }
    }
    , data() {
        var tmp_settings = {}
        if (localStorage.settings != undefined) {
            tmp_settings = JSON.parse(localStorage.settings)
        }
        if (tmp_settings.GAS_LIMIT == undefined) {
            tmp_settings.GAS_LIMIT = 10000
        }

        return {
            ENUMS: ENUMS
            , cur_gas_limit: tmp_settings.GAS_LIMIT

        }
    }
}

</script>

<style scoped>
input {
    color: black;
    text-align: center;
}

.settholder {
    display: flex;
    flex-direction: column;
    padding-left: 10%;
    padding-right: 10%;
    row-gap: 20px;
    border-style: solid;
    border-color: white;
    padding: 10%;
    padding-top: 2%;
    padding-bottom: 2%;
}
</style>